import React, { useState, useEffect } from "react";
import {SinhalaData, EnglishData, TamilData} from  "./../../../../dummyData/handbookDummyData";
import { useSelector } from "react-redux";

const Chapter7 = () => {
    const selectedLanguage = useSelector((state) => state.language.language);
  const [language, setLanguage] = useState(SinhalaData[0]);

    useEffect(() => {
        switch (selectedLanguage.value) {
          case "english":
            setLanguage(EnglishData[0]);
            break;
          case "tamil":
            setLanguage(TamilData[0]);
            break;
          default:
            setLanguage(SinhalaData[0]);
            break;
        }
      }, [selectedLanguage]);

    return (
        <>

             {/* Chapter 7 */}
                <section id="section7" className="drivers-handbook-section">
                    <h2 className="drivers-handbook-heading">
                       {language.chapter7Title}
                    </h2>

                    <h3 className="drivers-handbook-subheading">{language.chapter7Subheading1}</h3>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter7Paragraph1}
                    </p>

                    <p className="drivers-handbook-paragraph">
                         {language.chapter7Paragraph2}
                    </p>


                    <ul className="drivers-handbook-list">
                        <li>{language.chapter7List11}</li>
                        <li>
                            {language.chapter7List12}
                        </li>
                        <li>{language.chapter7List13}
                        </li>
                        <li>
                            {language.chapter7List14}
                        </li>
                        <li>
                            {language.chapter7List15}
                        </li>

                        <h3 className="drivers-handbook-subheading">{language.chapter7Subheading2}</h3>


                        <li>
                            {language.chapter7List21}
                        </li>

                        <li>
                             {language.chapter7List22}
                        </li>

                        <li>
                             {language.chapter7List23}
                        </li>

                        <li>
                             {language.chapter7List24}
                        </li>


                        <li> {language.chapter7List25}
                        </li>

                        <li> {language.chapter7List26}
                        </li>

                        <li> {language.chapter7List27}
                        </li>

                        <li> {language.chapter7List28}
                        </li>

                        <li> {language.chapter7List29}
                        </li>
                        <li>
                             {language.chapter7List30}

                        </li>
                        <li> {language.chapter7List31}
                        </li>
                    </ul>
                </section>
        </>
    )

}

export default Chapter7;
